import EventCard from 'components/platform/card/EventCard';
import React from 'react';
import Switch from 'react-switch'
import { Card, CardImg } from 'reactstrap';

import { AppConfig } from 'config/app';


export default class CardViewPublic extends React.Component<{ [label: string]: any }, { [label: string]: any }> {

    constructor(props) {
        super(props)
        this.state = {
            active: true
        }
        this.changeActiveFinished = this.changeActiveFinished.bind(this);
    }

    public changeActiveFinished() {
        this.setState({ active: !this.state.active })
    }

    public render() {
        return (
            <div>
                <div className="big-split">
                    <div>
                        {
                            this.props.insideCheckoutPage ? null :
                                <div>
                                    <h3 className="sexyBlack" style={{ paddingLeft: '100px', color: '#151726' }}>Upcoming</h3>
                                    <p><br /></p>
                                </div>
                        }
                        <div style={{
                            display: "flex", overflowX: "scroll"
                        }}>
                            {this.props.events && this.props.events.length > 0
                                ? this.props.activeEvents.map((event: any, index) => {
                                    return (
                                        <div style={{ marginRight: '33px' }} key={"event-" + event.id} id={"event-" + event.id}>
                                            <a
                                                href=
                                                {
                                                    AppConfig.hostUrl + '/event-' + event.urlHash
                                                }
                                                style={{ textDecoration: 'none' }}
                                            >
                                                <Card
                                                    style={{
                                                        width: '360px',
                                                        cursor: 'pointer',
                                                        marginBottom: '45px',
                                                        borderRadius: '15px'
                                                    }}>
                                                    <div style={{ height: '140px', overflowY: 'hidden' }}>
                                                        <CardImg top={true}
                                                            src={
                                                                event.styling.promoImg
                                                                    ? event.styling.promoImg
                                                                    : 'https://platform.isotopeticketing.com/landing.png'
                                                            }
                                                            alt="Event Image"
                                                            style={{
                                                                borderTopLeftRadius: '15px',
                                                                borderTopRightRadius: '15px',
                                                                objectFit: 'contain'
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="events-page-manage-inside">
                                                        <EventCard {...event} listItem={true} public={true} />
                                                    </div>
                                                </Card>
                                            </a>
                                        </div>

                                    );
                                })
                                : <div style={{ paddingLeft: '100px' }}>
                                    <h1>
                                        <br />No other upcoming events.
                                        <br /><br /><br />
                                    </h1>
                                </div>
                            }
                        </div>
                    </div>
                    {
                        this.props.insideCheckoutPage ? null :
                            <div>
                                <h3 className="sexyBlack" style={{ paddingLeft: '100px', color: '#151726' }}>Finished</h3><p><br /></p>
                                <div style={{
                                    display: "flex", overflowX: "scroll"
                                }}>
                                    {this.props.events && this.props.inactiveEvents.length > 0
                                        ? this.props.inactiveEvents.map((event: any, index) => {
                                            return (
                                                <div style={{ marginRight: '33px' }} key={"event-" + event.id} id={"event-" + event.id}>
                                                    <Card
                                                        style={{
                                                            width: '360px',
                                                            cursor: 'pointer',
                                                            marginBottom: '45px',
                                                            borderRadius: '15px'
                                                        }}>
                                                        <div style={{ height: '140px', overflowY: 'hidden' }}>
                                                            <CardImg top={true}
                                                                src={
                                                                    event.styling.promoImg
                                                                        ? event.styling.promoImg
                                                                        : 'https://platform.isotopeticketing.com/landing.png'
                                                                }
                                                                alt="Event Image"
                                                                style={{
                                                                    borderTopLeftRadius: '15px',
                                                                    borderTopRightRadius: '15px',
                                                                    objectFit: 'contain'
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="events-page-manage-inside">
                                                            <EventCard {...event} listItem={true} public={true} />
                                                        </div>
                                                    </Card>
                                                </div>

                                            );
                                        })
                                        : <div style={{ paddingLeft: '100px' }}>
                                            <h1><br />
                                                No past events.
                                        <br /><br />
                                            </h1>
                                        </div>
                                    }
                                </div>
                            </div>
                    }
                </div>
                <div className="small-split">
                    {
                        this.props.insideCheckoutPage ? null :
                            <div style={{ width: '100%', justifyContent: 'center', display: 'flex' }}>
                                <div>
                                    <span style={{ height: '20px', lineHeight: '15px', color: '#151726' }}>
                                        Upcoming&nbsp;&nbsp;</span>
                                    <span style={{ height: '20px', lineHeight: '15px', paddingTop: '3px' }}>
                                        <Switch
                                            checked={!this.state.active}
                                            onChange={this.changeActiveFinished}
                                            onColor="#4d5adf"
                                            onHandleColor="#ffffff"
                                            handleDiameter={20}
                                            uncheckedIcon={false}
                                            checkedIcon={false}
                                            boxShadow="0 2px 1px -1px gray"
                                            height={20}
                                            width={35}
                                            className="react-switch"
                                            id="material-switch"
                                        />
                                    </span>
                                    <span style={{ height: '20px', lineHeight: '15px', color: '#151726' }}>
                                        &nbsp;&nbsp;Finished</span>
                                </div>
                                <p><br /></p>
                            </div>
                    }
                    {this.state.active && this.props.events && this.props.events.length > 0
                        ? this.props.activeEvents.map((event: any, index) => {
                            return (
                                <div key={"event-" + event.id} id={"event-" + event.id}>
                                    <a
                                        href=
                                        {
                                            AppConfig.hostUrl + '/event-' + event.urlHash
                                        }
                                        style={{ textDecoration: 'none' }}
                                    >
                                        <Card
                                            style={{
                                                width: '360px',
                                                cursor: 'pointer',
                                                marginBottom: '45px',
                                                borderRadius: '15px',
                                                maxWidth: '105%'
                                            }}>
                                            <div style={{ height: '140px', overflowY: 'hidden' }}>
                                                <CardImg top={true}
                                                    src={
                                                        event.styling.promoImg
                                                            ? event.styling.promoImg
                                                            : 'https://platform.isotopeticketing.com/landing.png'
                                                    }
                                                    alt="Event Image"
                                                    style={{
                                                        borderTopLeftRadius: '15px',
                                                        borderTopRightRadius: '15px',
                                                        objectFit: 'contain'
                                                    }}
                                                />
                                            </div>
                                            <div className="events-page-manage-inside">
                                                <EventCard {...event} listItem={true} public={true} />
                                            </div>
                                        </Card>
                                    </a>
                                </div>

                            );
                        })
                        : this.state.active ? <div><h1><br />No other upcoming events.<br /><br /><br /></h1></div> : null}
                    {!this.props.insideCheckoutPage && !this.state.active && this.props.events && this.props.inactiveEvents.length > 0
                        ? this.props.inactiveEvents.map((event: any, index) => {
                            return (
                                <div key={"event-" + event.id} id={"event-" + event.id}>

                                    <Card
                                        style={{
                                            width: '360px',
                                            cursor: 'pointer',
                                            marginBottom: '45px',
                                            borderRadius: '15px',
                                            maxWidth: '105%'
                                        }}>
                                        <div style={{ height: '140px', overflowY: 'hidden' }}>
                                            <CardImg top={true}
                                                src={
                                                    event.styling.promoImg
                                                        ? event.styling.promoImg
                                                        : 'https://platform.isotopeticketing.com/landing.png'
                                                }
                                                alt="Event Image"
                                                style={{
                                                    borderTopLeftRadius: '15px',
                                                    borderTopRightRadius: '15px',
                                                    objectFit: 'contain'
                                                }}
                                            />
                                        </div>
                                        <div className="events-page-manage-inside">
                                            <EventCard {...event} listItem={true} public={true} />
                                        </div>
                                    </Card>

                                </div>

                            );
                        })
                        : !this.state.active ? <div><h1><br />No past events.<br /><br /></h1></div> : null}
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/manage/events/manage/CardViewPublic.tsx